import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import jui from 'join-ui' // 引入组件库
import 'join-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import './assets/icons'
import './icons' // icon 引入图标
import './permission' // permission control
import './utils/errorLog' // error log

import Print from 'vue-print-nb'
Vue.use(Print)

console.log('xxxx', process.env)

// import '../public/static/ueditor/ueditor.config.js'
// import '../public/static/ueditor/ueditor.all.js'
// import '../public/static/ueditor/lang/zh-cn/zh-cn.js'
// // import '../public/static/ueditor/ueditor.parse.min.js'
// import '../public/static/ueditor/kityformula-plugin/addKityFormulaDialog.js'
// import '../public/static/ueditor/kityformula-plugin/getKfContent.js'
// import '../public/static/ueditor/kityformula-plugin/defaultFilterFix.js'
// import '../public/static/ueditor/themes/default/css/ueditor.css'

import TMap from 'qqmap'
Vue.use(TMap)

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'pYNskAU5yNDInxABaC3agTroXNy6wKEY'
})

import * as filters from './filters' // global filters
// 图片预览组件 SanF修改自https://github.com/826327700/vue-photo-preview/
import preview from '@/components/PhotoPreview'
Vue.use(preview)

Vue.use(jui)

import auth from './utils/userAuth/auth'
Vue.use(auth)

// import { mockXHR } from '../mock' // simulation data

// // mock api in github pages site build
// if (process.env.NODE_ENV === 'production') { mockXHR() }
import mixin from './mixins/mixin'
Vue.mixin(mixin)
Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  zIndex: 100
})
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 挂载echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import { resetForm } from '@/utils'
Vue.prototype.resetForm = resetForm

import modal from '@/utils/modal'
Vue.prototype.$modal = modal

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
